import React from 'react';
import { Play } from 'lucide-react';

const StickyWatchBar = ({ visible, onWatch }) => {
  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.12)] flex items-center gap-3 p-3 pr-3 max-w-[420px]">
        {/* Thumbnail */}
        <div className="w-[64px] h-[48px] rounded-xl overflow-hidden flex-shrink-0">
          <img
            src="https://customer-assets.emergentagent.com/job_page-recreate-1/artifacts/yfoomgm2_Screenshot%202026-02-26%20at%2011.49.18.png"
            alt="Talk thumbnail"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-900 truncate">
            Talk "Costruire una now-next...
          </p>
          <p className="text-xs text-gray-500 flex items-center gap-1 mt-0.5">
            <Play className="w-2.5 h-2.5 fill-gray-500 text-gray-500" />
            48:42
          </p>
        </div>

        {/* Watch Button */}
        <button
          onClick={onWatch}
          className="px-6 py-2.5 bg-indigo-500 hover:bg-indigo-600 text-white rounded-full text-sm font-medium transition-colors duration-200 flex-shrink-0"
        >
          Watch
        </button>
      </div>
    </div>
  );
};

export default StickyWatchBar;
